/*
 * @Author: tanyaohua
 * @Date: 2022-02-24 17:43:16
 * @FilePath: \MCN_new\app\utils\trsSce\trsSce.js
 * @Description: 
 */
angular.module('trsSceModule', [])
    .filter("trsSce", ['$sce', function($sce) {
        return function(input) {
            if (angular.isDefined(input)) {
                // input = $sce.trustAsHtml(window.filterXSS(input));
                input = $sce.trustAsHtml(input);
            }
            return input;
        };
    }])
    .filter("trsSceUrl", ["$sce", function($sce) {
        return function(input) {
            if (angular.isDefined(input)) {
                input = $sce.trustAsUrl(input);
            }
            return input;
        }
    }])